import _ from 'lodash';

import * as PositionManager from 'Utils/PositionManager';
import * as SlideSelectors from './SlideSelectors';

import SlideConstants from './SlideConstants';

export function slides(state = {}, action) {
    switch (action.type) {
        case SlideConstants.SLIDE_RECEIVED:
            const newState = {
                ...state
            };

            const slide = action.payload;

            newState[slide.id] = {
                id: slide.id.toString(),
                story_id: slide.story_id.toString(),
                position: slide.position,
                type: slide.slide_type,
                data: JSON.parse(slide.data),
            };

            return newState;
            break;
        case SlideConstants.SLIDE_REMOVED:
            return _.pickBy(state, slide => slide.id !== action.payload.id);
            break;
        case SlideConstants.SLIDE_MOVED:
            const movingSlide = SlideSelectors.findById({ slides: state }, action.payload.id);
            const storySlides = SlideSelectors.filterByStoryId({ slides: state }, movingSlide.story_id);

            const reorderedSlides = PositionManager.move(
                storySlides,
                movingSlide.id,
                action.payload.position
            );

            reorderedSlides.map(slide => {
                state[slide.id].position = slide.position;
            });

            return { ...state };

            break;
        case SlideConstants.SLIDE_CHANGING: {
            const {id, changes} = action.payload;
            const {data} = changes;

            const newState = {
                ...state
            };

            if (data) {
                newState[id].data = {
                    ...newState[id].data,
                    ...data
                };
            }

            return newState;
        }
        default:
            return state;
    }
}
